import { fromJS } from 'immutable'
export default fromJS({
  upload: { selectFile: 'Select document' },
  form: { name: 'Name: ${name}' },
  shared: {
    components: {
      form: {
        businessPlaceInput: {
          moreNearbyResults: 'Show further results nearby...',
          error: { couldNotFindNearbyResults: 'No results found nearby...' },
          noResultsMessage: 'No results found.',
          chosen: 'Selected location',
          label: 'Search by name or address...',
          choose: 'Please select',
          orClickOnMap: '...or click on the map',
          currentMarkerSelection: 'Current marker',
          nearby: 'Near',
        },
      },
    },
  },
  error: { network: 'Server could not be found: network error' },
  names: { lastName: 'Last Name', firstName: 'First name' },
  errors: {
    acceptance: 'Please confirm the checkbox.',
    default: 'Please complete this field',
    canNotConnectToServer: 'Connection to server failed',
    iban: 'Please enter a valid IBAN.',
    fileTooBig: 'File too big to upload',
    uploadBlocked: 'A document was blocked or could not be processed.',
    time: 'Please enter a valid format.',
    phone: 'Please provide a valid phone number',
    date: 'Please enter a valid date.',
    fileTooSmall: 'File too small to upload',
    currency: 'Please enter a valid amount',
    file: 'Please select a file',
    email: 'Please provide a valid email address.',
    boundaryError: 'An error has occurred.',
    inputContainsBinRange: 'Please do not enter your credit card number',
  },
  genders: { female: 'Ms.', male: 'Mr.' },
  button: { send: 'Send', delete: 'Remove' },
  address: { city: 'Town/city', zip: 'ZIP Code', street: 'Street' },
  confirmation: { backHome: 'Return to the homepage' },
  not_found: { title: 'Form not found' },
  format: { time: 'HH:MM', date: 'DD.MM.YYYY' },
  loading: { title: 'Loading...' },
})
